import React from 'react'
import { Variant as TypographyVariant } from '@mui/material/styles/createTypography'
import { SxProps } from '@mui/material/styles'
import { ConfigurableCtaOptions } from '@typesApp/PageFlow'
import { IconProps } from '@components/ui/Icon'
import { ButtonProps } from '@components/ui-css/Button'
import { ConfigurableAction } from '../Button'

type FooterActionProps = {
  renderAs: 'link' | 'button'
  underline?: boolean
  icon?: IconProps['name'] | 'none'
  label?: string
  onClick: () => void
  disableOnClick?: boolean
  typographyVariant?: TypographyVariant
  typographyColor?: string
  variant?: 'primary' | 'secondary'
  color?: ButtonProps['color']
  dataAttributes?: Record<string, string>
  sx?: SxProps
}

export const FooterAction: React.FC<FooterActionProps> = props => {
  const {
    renderAs,
    underline,
    label,
    icon,
    onClick,
    typographyVariant,
    typographyColor,
    variant,
    color,
    dataAttributes,
    sx,
    disableOnClick = false,
  } = props
  const options = {
    renderAs,
    underline,
    icon,
    typographyColor: typographyColor || 'inherit',
    typographyVariant,
    variant,
    sx,
  } as ConfigurableCtaOptions

  return (
    <ConfigurableAction
      options={options}
      onClick={onClick}
      label={label}
      color={color}
      dataAttributes={dataAttributes}
      disableOnClick={disableOnClick}
    />
  )
}
